import { FieldListObject } from '@fabric-ui/components';
import { FINDING_RISK_SCORE, FINDING_SEVERITY_SCORE } from '@views/Tickets/ticket.types';

export const filterJsonFields = field => !['["MESSAGE"]', 'MESSAGE'].includes(field.type?.toString());

export const getFilteredOneToOneFields = (fieldListWithOneToOne: FieldListObject[], excludeList, fields) =>
  fieldListWithOneToOne.filter(
    v =>
      !v.visibilityConfig.config.hidden &&
      ![...(excludeList?.aliases || []), ...(excludeList?.fields || [])].some(substring => v.value.includes(substring)) &&
      !fields.fields.flatMap(v => v.map(({ field }) => field)).includes(v.value) &&
      filterJsonFields(v)
  );

export const getFindingScoreField = (isNewRiskScoreEnabled?: boolean): string =>
  isNewRiskScoreEnabled ? FINDING_RISK_SCORE : FINDING_SEVERITY_SCORE;
